import React, { Component } from 'react'

import { ElementIcons } from '../../elements/icons'

// Elements
import Text from '../../elements/text'
import Icon from '../../elements/icon'
import Inline from '../../elements/inline'

// import styles
import './inputstate.scss'

class InputState extends Component {

  constructor (props) {
    super(props)
    this.state = {
      option: this.props.option,
      value: this.props.value
    }
    this.changeInputState = this.changeInputState.bind(this)
    this.onChange = this.onChange.bind(this)
  }

  componentWillReceiveProps (nextProps) {
    this.setState({
      option: nextProps.option,
      value: nextProps.value
    })
  }

  changeInputState () {
    let option = this.state.option
    if (option === 4) {
      option = 0
    }
    this.setState({
      option: option + 1
    })
    this.props.triggerHandler(option + 1, this.props.triggerName)
  }

  onChange (e) {
    this.setState({
      value: e.target.value
    })
    this.props.triggerChange(e)
  }

  render () {
    let stateImage = ElementIcons.Include
    if (this.state.option === 2) { stateImage = ElementIcons.Empty }
    if (this.state.option === 3) { stateImage = ElementIcons.Filled_In }
    if (this.state.option === 4) { stateImage = ElementIcons.Exclude }

    return (
      <Inline alignChildren={'center'}>
        <Text placeholder={this.props.placeholder} name={this.props.triggerName} value={this.state.value} onChange={this.onChange} />
        <span className='inputstate' onClick={this.changeInputState}>
          <Icon icon={stateImage} />
        </span>
      </Inline>
    )
  }

}

export default InputState



// WEBPACK FOOTER //
// ./src/app/shared/components/InputState/index.js